@if (IsLoading) {
    <app-loading-page [message]="LoadingMessage"></app-loading-page>
}
@else {
    <div class="page">
        <div class="header-button-combo">
            <div>
                <h2>Instances</h2>
            </div>
            <div class="btn-group no-stack">
                <button kendoButton look="outline" class="btn-back" (click)="showAllInstances()">Instances</button>
                @if (IsSaving) {
                    <button kendoButton [disabled]="true">Saving...</button>
                }
                @else {
                    <button kendoButton [disabled]="!instanceDirty" (click)="saveInstanceDetails()">Save</button>
                }
            </div>
        </div>
        <div>
            <div class="instance-details">
                <kendo-tabstrip>
                <kendo-tabstrip-tab title="General" [selected]="true">
                    <ng-template kendoTabContent>
                        <div class="input-wrapper">
                            <label>Name</label>
                            <input kendoTextBox [(ngModel)]="Instance.Name" [disabled]="IsSaving" />
                        </div>
                        <div class="input-wrapper">
                            <label>Description</label>
                            <textarea kendoTextArea [(ngModel)]="Instance.Description" [disabled]="IsSaving"></textarea>
                        </div>
                        <div class="input-wrapper">
                            <label>Created</label>
                            <span class="instance-field">{{ Instance.__mj_CreatedAt | date: 'short' }}</span>
                        </div>
                        <div class="input-wrapper">
                            <label>Status</label>
                            <span class="instance-field">{{ Instance.Status }}</span>
                        </div>
                        <div class="input-wrapper">
                            <label>Access Level</label>
                            <kendo-dropdownlist 
                            class="instance-dropdown"
                            [data]="possibleAccessLevels"
                            [(ngModel)]="Instance.AccessLevel"
                            [disabled]="IsSaving"
                            >
                            </kendo-dropdownlist>
                        </div>
                        <div class="input-wrapper">
                            <label>Instance ID</label>
                            <span class="instance-field instance-id">{{ Instance.ID }}</span>
                        </div>
                    </ng-template>
                </kendo-tabstrip-tab>
                <kendo-tabstrip-tab title="Roles">
                    <ng-template kendoTabContent>
                        <div class="mb-3">
                            <button kendoButton class="btn-add" (click)="addNewInstanceRole()" [disabled]="IsSaving">Add Role</button>
                        </div>
                        <div class="grid-wrapper grid-sm">
                            <kendo-grid [data]="InstanceRoles" [scrollable]="'scrollable'" [resizable]="true"> 
                                <kendo-grid-column field="Name">
                                </kendo-grid-column>
                                <kendo-grid-column field="Description">
                                </kendo-grid-column>
                                <kendo-grid-column title="Actions" [width]="255">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <div class="btn-group no-stack">
                                        <button kendoButton class="btn-edit" (click)="editInstanceRole(dataItem)" [disabled]="IsSaving">
                                            Edit
                                        </button>
                                        <button kendoButton class="btn-delete" (click)="deleteInstanceRole(dataItem)" [disabled]="IsSaving">
                                            Delete
                                        </button>
                                    </div>
                                </ng-template>
                                </kendo-grid-column>
                            </kendo-grid>
                        </div>
                    </ng-template>
                </kendo-tabstrip-tab>
                @if (Instance.AccessLevel === "Owner + Admin + Specific Users") {
                    <kendo-tabstrip-tab title="Team Member Access">
                        <ng-template kendoTabContent>
                            <button kendoButton class="btn-add mb-4" (click)="openAddUserPopup()">Add Member</button>
                            <div class="grid-wrapper grid-md">
                                <kendo-grid [data]="ActiveInstanceContactList" [scrollable]="'scrollable'" [resizable]="true">
                                    <kendo-grid-column title="Team Member">
                                        <ng-template kendoGridHeaderTemplate let-column>
                                            Team Member 
                                        </ng-template>
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            <span>{{ dataItem.oc.Contact }}</span>
                                        </ng-template>
                                    </kendo-grid-column>
                                    <!-- <kendo-grid-column title="Active">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <input type="checkbox" [checked]="dataItem.ic?.IsActive" (change)="onIsActiveChanged($event, dataItem)" [disabled]="IsSaving"/>
                                    </ng-template>
                                    </kendo-grid-column> -->
                                    <kendo-grid-column title="Role">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        @if (dataItem.ic && dataItem.ic.IsActive) {
                                            <kendo-multiselect
                                                [data]="InstanceRoles"
                                                textField="Name"
                                                valueField="ID"
                                                [(ngModel)]="dataItem.selectedRoles"
                                                (valueChange)="onInstanceRolesChanged($event)"
                                                [disabled]="IsSaving"
                                            ></kendo-multiselect>
                                        }
                                    </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column title="Access Starts">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        @if (dataItem.ic && dataItem.ic.IsActive) {
                                            <kendo-datepicker [(value)]="dataItem.ic.StartsAt"  placeholder="" [disabled]="IsSaving"></kendo-datepicker>
                                        }
                                    </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column title="Access Ends">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        @if (dataItem.ic && dataItem.ic.IsActive) {
                                            <kendo-datepicker [(value)]="dataItem.ic.EndsAt" placeholder="" [disabled]="IsSaving"></kendo-datepicker>
                                        }
                                    </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column title="Remove" [width]="150">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            <button kendoButton 
                                                    class="btn-delete"
                                                    look="outline" 
                                                    (click)="onRemoveUser(dataItem)"
                                                    [disabled]="IsSaving">
                                                Remove
                                            </button>
                                        </ng-template>
                                    </kendo-grid-column>
                                </kendo-grid>
                            </div>
                        </ng-template>
                    </kendo-tabstrip-tab>
                }
                </kendo-tabstrip>
            </div>
        </div>

        @if(isEditingInstanceRole) {
            <kendo-dialog (close)="cancelEditingInstanceRole()">
                <kendo-dialog-titlebar>
                @if (selectedInstanceRole.IsSaved) {
                    <span>Edit Role</span>
                }
                @else {
                    <span>Add Role</span>
                }
                </kendo-dialog-titlebar>
                <kendo-dialog-content>
                    <div class="input-wrapper">
                        <label>Name</label>
                        <input kendoTextBox [(ngModel)]="selectedInstanceRole.Name"/>
                    </div>
                    <div class="input-wrapper">
                        <label>Description</label>
                        <input kendoTextBox [(ngModel)]="selectedInstanceRole.Description"/>
                    </div>
                </kendo-dialog-content>
                <div class="btn-group no-stack">
                    <button kendoButton (click)="saveSelectedInstanceRole()">Save</button>
                    <button kendoButton look="outline" (click)="cancelEditingInstanceRole()">Cancel</button>
                </div>
            </kendo-dialog>  
        }

        <!-- Remove User Dialog -->
        @if (showRemoveUserDialog) {
            <kendo-dialog (close)="showRemoveUserDialog = false" title="Remove User">
                <p>Are you sure you want to remove {{ userToRemove?.Contact }} from this subscription?</p>
                <!-- Subscription Update Preview -->
                <app-subscription-update-preview
                    [subscription]="Subscription"
                    [options]="previewOptions"
                    (previewLoaded)="onPreviewLoaded($event)"
                >
                </app-subscription-update-preview>
                <div class="btn-group no-stack">
                    <button kendoButton [disabled]="!isPreviewLoaded" themeColor="error" (click)="confirmRemoveUser()">Confirm</button>
                    <button kendoButton look="outline" (click)="showRemoveUserDialog = false">Cancel</button>
                </div>
            </kendo-dialog>
        }

        <!-- Add User Dialog -->
        @if (showAddUserPopup) {
            <kendo-dialog (close)="closeAddUserPopup()">
            <kendo-dialog-titlebar>
                Add Users to Instance
            </kendo-dialog-titlebar>
            <div class="dialog-content">
                @if (newUserDialogPage === 1) {
                <!-- Page 1: List inactive contacts with checkboxes -->
                <div class="form-group">
                    <p>
                        Select contacts to add ({{ newSelectedContacts.length }} selected out of {{ availableSlots < 2000000000 ? availableSlots : 'unlimited'  }} slots available):
                    </p>
                    <div class="contact-list">
                    @for (contact of InactiveInstanceContactList; track contact) {
                        <div class="contact-option">
                            <p>
                                <kendo-checkbox [id]="contact.oc.ContactID" 
                                    (change)="toggleContactSelection(contact.oc.ContactID, $event)"
                                    [checked]="isContactSelected(contact.oc.ContactID)"
                                    [disabled]="newSelectedContacts.length >= availableSlots && !isContactSelected(contact.oc.ContactID)"
                                >
                                </kendo-checkbox>
                                <kendo-label
                                    class="k-checkbox-label"
                                    [attr.for]="contact.oc.ContactID"
                                >
                                    {{ contact.oc.Contact }}
                                </kendo-label>
                                
                            </p>
                        </div>
                    }
                    </div>
                </div>
                <div class="btn-group no-stack">
                    <button kendoButton (click)="newUserDialogPage = 2" [disabled]="newSelectedContacts.length === 0">
                        Next
                    </button>
                    <button kendoButton look="outline" (click)="closeAddUserPopup()">Cancel</button>
                </div>
                } @else if (newUserDialogPage === 2) {
                <!-- Page 2: Preview the subscription update -->
                <h4>Additional Monthly Costs</h4>
                <div class="preview-container">
                    <app-subscription-update-preview 
                    [subscription]="Subscription"
                    [options]="getPreviewOptionsForAdd()"
                    (previewLoaded)="onAddPreviewLoaded($event)">
                    </app-subscription-update-preview>
                </div>
                <div class="btn-group no-stack">
                    <button kendoButton look="outline" (click)="newUserDialogPage = 1">
                    Back
                    </button>
                    <button kendoButton (click)="confirmAddUsers()" [disabled]="!addPreviewLoaded">
                    Confirm
                    </button>
                </div>
                }
            </div>
            </kendo-dialog>
        }
  
    </div>
}
